import {Rate} from "@/lib/types/calulator/upgrad";
import BubbleService from "@/services/Bubble/BubbleService";
import axios from "axios";
import xml from 'xml-js'
import {DEFAULT_EXCHANGE_CURRENCY, ExchangeCurrency} from "@/lib/types/config";

class CalculatorService {

    constructor() {

    }

    protected pmt = (amount: number, month: number, rate: number) => {
        rate = rate / 12;
        let result =
            (rate * amount) /
            (1 - Math.pow(1 + rate, -month));
        return Math.round(result);
    };

    public fetchRates = async () => {
        try {
            const bubbleService = new BubbleService()
            const data: any = await bubbleService.getWf('rate')
            return data
        } catch (error) {
            throw error
        }
    }

    public fetchExchangeCurrency = async () => {
        try {
            const xmlData = await axios.get('https://portal.vietcombank.com.vn/Usercontrols/TVPortal.TyGia/pXML.aspx')
            // @ts-ignore
            let data:any = xml.xml2json(xmlData.data,{compact: false,spaces:4})
            data = JSON.parse(data)
            data = data.elements[1].elements
            data.shift()
            data.pop()
            data = data.map((item:any,index:any) => {
                return {
                    CurrencyCode: item.attributes.CurrencyCode.trim(),
                    CurrencyName: item.attributes.CurrencyName.trim(),
                    Buy: Number(item.attributes.Buy.replace(/,/g, '')),
                    Transfer: Number(item.attributes.Transfer.replace(/,/g, '')),
                    Sell: Number(item.attributes.Sell.replace(/,/g, ''))
                }
            })
            return data
        }catch(error) {
            console.log(error)
        }
    }


    public convertAmountCurrency = (amount:number, currency: string, exchangeCurrency:ExchangeCurrency[]):number => {
        const exchangeResult = exchangeCurrency.find(item => {
            return item.CurrencyCode == currency
        })
        let baseAmount = exchangeResult?.Sell ?? 0
        let diffPercent = currency == "USD" ? 0.1 : 0.3
        baseAmount = baseAmount + Math.round((baseAmount * diffPercent))
        return amount * baseAmount
    }

    public getExchangeCurrency = (currency:string, exchangeCurrency:ExchangeCurrency[]):ExchangeCurrency => {
        const exchangeResult = exchangeCurrency.find(item => {
            return item.CurrencyCode == currency
        })
        return exchangeResult ?? DEFAULT_EXCHANGE_CURRENCY
    }
}

export default CalculatorService